import type { GeneratedDocument } from '../types/agreementDocuments.types';
import { PENDING_POLL_WINDOW_MS } from './generatedDocumentDisplay';

export const DOCUMENT_POLL_INTERVAL_MS = 5000;

/** Polls only while a recent row is pending: every poll is a gated read of the agreement. */
export const documentPollInterval = (documents: readonly GeneratedDocument[], now: number): number | false =>
    documents.some((document) => document.status === 'pending' && now - Date.parse(document.createdAt) < PENDING_POLL_WINDOW_MS)
        ? DOCUMENT_POLL_INTERVAL_MS
        : false;
